import { initialState, initialStateByModule } from './state'
import { get, set, defaults, isObject } from 'lodash'
import { capitalize } from '@/filters'

const CHANGE_ASYNC_PENDING = 'changeAsyncPending'

const CHANGE_PROPERTY = 'changeProperty'
const CHANGE_UUID = 'changeUuid'
const CHANGE_OPT_IN = 'changeOptIn'
const CHANGE_DATE_OF_BIRTH = 'changeDateOfBirth'

const RESET = 'resetUser'
const RESET_LIST_PASSENGERS = 'resetListPassengers'
const CHANGE_LIST_PASSENGERS = 'changeListPassengers'
const CHANGE_PASSENGER = 'changePassenger'
const CHANGE_INVALID_PASSENGER = 'changeInvalidPassenger'

const CHANGE_VOUCHER_RECIPIENT_NAME = 'changeVoucherRecipientName'
const CHANGE_VOUCHER_RECIPIENT_EMAIL = 'changeVoucherRecipientEmail'

const state = initialStateByModule('user')

const mutations = {
  [RESET] (state) {
    const s = initialState.user
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
  [CHANGE_ASYNC_PENDING] (state, payload) {
    state.asyncPending = payload
  },
  [CHANGE_PROPERTY] (state, { field, value }) {
    if (isObject(value)) {
      const oldValue = get(state, field)
      value = defaults(value, oldValue)
    }
    set(state, field, value)
  },
  [CHANGE_UUID] (state, payload) {
    state.uuid = payload
  },
  [CHANGE_OPT_IN] (state, payload) {
    state.optIn = !!payload
  },
  [CHANGE_DATE_OF_BIRTH] (state, payload) {
    state.dateOfBirth = payload
  },
  [RESET_LIST_PASSENGERS] (state) {
    state.passengers = []
  },
  [CHANGE_LIST_PASSENGERS] (state, payload) {
    state.passengers = payload.map(item => {
      item.name = capitalize(item.name)
      return item
    })
  },
  [CHANGE_PASSENGER] (state, payload) {
    state.passenger = !!payload
  },
  [CHANGE_INVALID_PASSENGER] (state, payload) {
    state.invalidPassenger = payload
  },
  [CHANGE_VOUCHER_RECIPIENT_NAME] (state, payload) {
    state.voucherRecipient.name = payload
  },
  [CHANGE_VOUCHER_RECIPIENT_EMAIL] (state, payload) {
    state.voucherRecipient.email = payload
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
